module.exports = __webpack_public_path__ + "img/20200905_150355.48f11e1e.jpg";